import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, List, ListItem, ListItemText, Typography } from '@material-ui/core'
import HistoryIcon from '@material-ui/icons/History'
import Loading from 'components/ui/Loading'
import { makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'
import _ from 'lodash'
import { formatArchiveForms, getHistory, getParams } from 'api/fieldNotebooks'
import HistoricItemsContents from './components/TabPanelHistoricContents/components/HistoricItemsContents'
import styles from './styles'
import './styles.css'

const useStyles = makeStyles(styles)

const HistoricForm = ({ archive, setIsHistoricFormSelected }) => {

  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)
  const [formSelected, setFormSelected] = useState()
  const [formTitle, setFormTitle] = useState('')
  const classes = useStyles()
  let history = useHistory()

  const handleFormHistorySelected = async (form) => {
    setLoading(true)
    try {
      const { jwt, company_id } = getParams(history.location.search)
      const params = {
        form_id: form.form_id ? form.form_id : null,
        company_id: company_id,
        jwt: jwt
      }
      const { data } = await getHistory(params)
      setFormSelected(data)
      setIsHistoricFormSelected(true)
      setFormTitle(form.title)
    } catch (error) {
      console.log(error)
    }
    setLoading(false)

  }

  if (_.isEmpty(archive)) {
    return <>{t('no_show_archive')}</>
  }


  const forms = formatArchiveForms(archive)
  const isSelected = !_.isUndefined(formSelected)

  return (
    loading
      ? <Loading />
      : <>
        {
          isSelected
            ?
            <Grid container className={classes.page__form}>
              <HistoricItemsContents
                classes={classes}
                formTitle={formTitle}
                setHistorySelected={setFormSelected}
                historySelected={formSelected}
                setIsHistoricFormSelected={setIsHistoricFormSelected}
              />
            </Grid>
            :
            <Grid container >
              <Grid item sm={12} xs={12}>
                <Typography className='archive_name'>
                  {archive.name}
                </Typography>
              </Grid>
              <List className={classes.List}>
                {forms.map(form => (
                  <Grid item sm={12} xs={12} key={form.form_id}>
                    <ListItem
                      alignItems='flex-start'
                      button onClick={() => handleFormHistorySelected(form)}
                      className={classes.List__root_item3}
                    >
                      <ListItemText
                        primary={form.title.toUpperCase()}
                        secondary={form.description}
                        primaryTypographyProps={{ color: 'primary' }}
                      />
                      <HistoryIcon fontSize='small' />
                    </ListItem>
                  </Grid>
                ))}
              </List>
            </Grid>
        }
      </>
  )
}

export default HistoricForm